import gamePic from "../media/screenShots/gamePic.png"
import Button from "react-bootstrap/Button"

const Home = () => (
  <>
    <h1>Welcome to Matt's Code Camp</h1>
    <p>Lets build a side scrolling plane shooter.</p>
    <img alt="Game Screenshot" src={gamePic} width={1000} height={600} />

    <br />
    <br />
    <Button type="button" variant="secondary" href="/Setup">
      Get Started
    </Button>
    <br />
    <br />
    <ul>
      <li>
        <a href="/Setup">Step 1 - Setup</a>
      </li>
      <li>
        <a href="/Config">Step 2 - Config</a>
      </li>
      <li>
        <a href="/Sprites">Step 3 - Sprites</a>
      </li>
      <li>
        <a href="/Animation">Step 4 - Animation</a>
      </li>
      <li>
        <a href="/PlayerInput">Step 5 - Player Input</a>
      </li>
      <li>
        <a href="/PlayerProjectiles">Step 6 - Player Projectiles</a>
      </li>
      <li>
        <a href="/Enemies">Step 7 - Enemies</a>
      </li>
      <li>
        <a href="/CollisionDetection">Step 8 - Collision Detection</a>
      </li>
      <li>
        <a href="/KeepingScore">Step 9 - Keeping Score</a>
      </li>
      <li>
        <a href="/Sound">Step 10 - Sound</a>
      </li>
    </ul>
  </>
)

export default Home
